<div class="row">
  <div class="container">
    <div class="col-md-12" class="fs16">
      <div class="card">
        <div class="card-header">
          <i style="margin-left: 1%" class="material-icons"
            >notification_important</i
          >
          <h2 style="text-align: center; margin-left: 1%">
            {{ detailedAlarm.name }}
          </h2>
        </div>
        <div class="card-body flexChildren">
          <div>
            <p>
              <b>{{ "ALARM.SUBJECT" | translate }}:</b>
              {{ detailedAlarm.subject }}
            </p>
          </div>

          <div>
            <p>
              <b>{{ "ALARM.BODY" | translate }}:</b>
              {{ detailedAlarm.body | NullFormat }}
            </p>
          </div>

          <div>
            <p>
              <b>{{ "ALARM.DESCRIPTION" | translate }}:</b>
              {{ detailedAlarm.description | NullFormat }}
            </p>
          </div>

          <div>
            <p>
              <b>{{ "ALARM.STATE" | translate }}:</b> {{ detailedAlarm.state }}
            </p>
          </div>

          <div>
            <p>
              <b>{{ "ALARM.TYPE" | translate }}:</b>
              {{ detailedAlarm.type.name }}
            </p>
          </div>

          <div>
            <p>
              <b>{{ "ALARM.VALUE" | translate }}:</b>
              {{ detailedAlarm.param.valor }}
            </p>
          </div>

          <div>
            <p>
              <b>{{ "ALARM.DATA" | translate }}: </b>
            </p>
          </div>

          <ul *ngFor="let device of detailedAlarm.devices">
            <p>
              <b>{{ "LATEST-MEASUREMENTS.DISPOSITIVO" | translate }}: </b
              >{{ device.name }}
            </p>
            <span *ngFor="let datatype of device.dataType">
              <p>
                <b>{{ "ALARM.DATATYPE" | translate }}: </b>{{ datatype.name }}
              </p>
              <p>
                <b>{{ "TAB_STEPPER.UNITY" | translate }}: </b
                >{{ datatype.unity }}
              </p>
            </span>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
